import Model, { attr, belongsTo } from '@ember-data/model';
import type CompanyModel from './company.ts';
import type EmployeeModel from './employee.ts';
import { Type } from '@warp-drive/core-types/symbols';

export default class ContributionModel extends Model {
  @attr declare amount: number;
  @attr declare balance: number;
  @attr declare status: string;
  @attr declare type: string;
  @attr declare createdAt: string;

  /*************************
   **  Relationships      **
   *************************/

  @belongsTo('company', { async: false, inverse: null })
  declare company: CompanyModel;
  @belongsTo('employee', { async: false, inverse: null })
  declare employee: EmployeeModel;

  [Type] = 'contribution' as const;
}
